export const CREATE_DRAFT = 'benefitCreatePage/CREATE_DRAFT';

export const FETCH_ITEM = 'benefitCreatePage/FETCH_ITEM';

export const GO_TO_STEP_ONE = 'benefitCreatePage/GO_TO_STEP_ONE';

export const GO_TO_STEP_TWO = 'benefitCreatePage/GO_TO_STEP_TWO';

export const SUBMIT = 'benefitCreatePage/SUBMIT';
